import React, {PureComponent} from "react"

import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"
import {H5} from "@irati/ui/src/Headings"
import {InlineBold} from "./styled"

class Step3Content extends PureComponent {
  render() {
    const boldText = (
      <InlineBold>
        <FormattedMessage id="setup_tenant.tour.step3.boldText" />
      </InlineBold>
    )

    return (
      <>
        <H5 tiny bold>
          <FormattedMessage id="setup_tenant.tour.step3.title" />
        </H5>
        <Para>
          <FormattedMessage id="setup_tenant.tour.step3.content" values={{boldText}} />
        </Para>
      </>
    )
  }
}

export default Step3Content
